import { useQuery } from "@apollo/client";
import { Select, Skeleton } from "@chakra-ui/react";
import { graphql } from "gql.tada";

import type { InputMaybe } from "@/generated/graphql";

import { ErrorBoundaryWithFeedback } from "@/app/components/ErrorBoundaryWithFeedback";
import { reportErrorOr404 } from "@/app/utils/report";

const SEQUENCES_QUERY = graphql(`
  query Sequences {
    sequenceTemplates {
      id
      name
    }
  }
`);

export function SequenceInput({
  value,
  onChange,
}: {
  value: {
    sequenceId: InputMaybe<string>;
  };
  onChange: (value: { sequenceId: InputMaybe<string> }) => void;
}) {
  const { data, loading, error } = useQuery(SEQUENCES_QUERY);
  if (loading) return <Skeleton h="34px" />;
  const sequences = data?.sequenceTemplates;
  if (error || !sequences) {
    return reportErrorOr404({ error, type: "SequenceTemplateType" });
  }

  return (
    <ErrorBoundaryWithFeedback>
      <Select
        value={value.sequenceId ?? ""}
        onChange={(event) =>
          onChange({
            sequenceId: event.target.value,
          })
        }
        placeholder="Select a Cadence"
      >
        {sequences.map((sequence) => {
          const displayValue = sequence.name;
          return (
            <option key={sequence.id} value={sequence.id}>
              {displayValue}
            </option>
          );
        })}
      </Select>
    </ErrorBoundaryWithFeedback>
  );
}
